import mutations from './mutations';
import getters from './getters';
import actions from './actions';
export default {
  namespaced: true,
  state() {
    return {
      subscriptionSuccessData:null,
      subscriptionErrorMessage:null,
      failedToDeleteSubscription:null,
      subscriptionDeleted:null,
      failedToListActiveSubscription:null,
      subscriptionList:null,
      whitelisted: null,
      failedToFetchCardList:null,
      cardLists:null,
      failedToListInvoice:null,
      invoiceList:null,
      failedToDelete:null,
      listSubscriptionPlans: null,
      failedToFetchProductListMessage: null,
      userBasedPlanInfo: null,
      failedToFetchPlansInfo:null
    };
  },
  mutations,
  actions,
  getters,
};
